module.exports = __webpack_public_path__ + "img/mission_Image_two.b0b9d869.png";